import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RedirectService {
  constructor() {}

  goTo(url: string, target = '_blank'): void {
    let newUrl = url;
    const utmSource = localStorage.getItem('utm_source');
    const utmMedium = localStorage.getItem('utm_medium');
    if (utmSource && utmMedium) {
      const newSourceParam = `utm_source=${utmSource}&utm_medium=${utmMedium}`;
      if (url.includes('?')) {
        newUrl = `${url}&${newSourceParam}`;
      } else {
        newUrl = `${url}?${newSourceParam}`;
      }
    }
    window.open(newUrl, target);
  }
}
